const getFrequencyAndDirection = (initiative) => {
  let frequency = '<not set>';

  initiative?.impact?.find(
    (i) => {
      if (i.frequencyAndDirection === 'Recurring Benefit (ETB)') {
        frequency = 'Recurring Benefit (ETB)';
        return true; // Return true to "find" this item
      }
      else if (i.frequencyAndDirection === 'Recurring Negative Impact (ETB)') {
        frequency = 'Recurring Negative Impact (ETB)';
        return true;
      }
      else if (i.frequencyAndDirection === 'One Time Benefit') {
        frequency = 'One Time Benefit'; // Fixed: = instead of ===
        return true;
      }
      // Don't return true for other cases
      return false;
    }
  );

  return frequency;
};

export default getFrequencyAndDirection;
